import {
  Badge,
  Box,
  Heading,
  HStack,
  Icon,
  SimpleGrid,
  Text,
  VStack,
  useColorModeValue,
} from "@chakra-ui/react";
import { motion } from "framer-motion";
import { FiCheckCircle, FiShield } from "react-icons/fi";

const MotionBox = motion(Box);
const MotionVStack = motion(VStack);

export const ContactIntro = () => {
  const textColor = useColorModeValue("gray.800", "white");
  const subtitleColor = useColorModeValue("gray.600", "gray.400");
  const cardBg = useColorModeValue("gray.50", "whiteAlpha.50");
  const borderColor = useColorModeValue("gray.100", "gray.700");
  const iconBg = useColorModeValue("brand.100", "icon.bg");
  const iconColor = useColorModeValue("brand.500", "icon.svg");

  const features = [
    {
      title: "پاسخ‌گویی شفاف",
      icon: FiCheckCircle,
      description:
        "شفافیت و پاسخگویی از اصول بنیادین تأمین سرمایه امید است. از ابتدای فعالیت، تلاش کرده ایم ارتباطی روشن و قابل اعتماد با سرمایه گذاران و مخاطبان خود برقرار کنیم",
    },
    {
      title: "ارتباط قابل اتکا",
      icon: FiShield,
      description:
        "ما خود را متعهد می دانیم که در مسیر ارائه خدمات مالی، پاسخگوی اعتماد شما باشیم و ارتباطی مؤثر و حرفه ای را حفظ کنیم",
    },
  ];

  return (
    <VStack spacing={8} textAlign="center">
      <MotionVStack
        spacing={5}
        initial={{ opacity: 0, y: 24 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.5 } as any}
      >
        <Badge
          colorScheme="brand"
          variant="subtle"
          px={3}
          py={1}
          borderRadius="full"
        >
          ارتباط موثر با سرمایه‌گذاران و مخاطبان
        </Badge>

        <Heading
          as="h2"
          fontSize={{ base: "2xl", md: "3xl" }}
          color={textColor}
          lineHeight="shorter"
        >
          چارچوب ارتباطی رسمی و پاسخ‌گو برای مخاطبان و سرمایه‌گذاران
        </Heading>

        <Text
          fontSize={{ base: "sm", md: "md" }}
          color={subtitleColor}
          maxW="760px"
          lineHeight="tall"
        >
          تأمین سرمایه امید با تأکید بر شفافیت در پاسخ‌گویی و ایجاد ارتباطی
          حرفه‌ای و قابل اتکا، مسیرهای ارتباطی این صفحه را برای دریافت اطلاعات،
          طرح درخواست و پیگیری مؤثر در اختیار مخاطبان قرار داده است.
        </Text>
      </MotionVStack>

      <SimpleGrid columns={{ base: 1, md: 2 }} spacing={5} w="100%">
        {features.map((feature, index) => (
          <MotionBox
            key={feature.title}
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.45, delay: index * 0.12 } as any}
          >
            <Box
              bg={cardBg}
              borderRadius="2xl"
              border="1px solid"
              borderColor={borderColor}
              p={{ base: 5, md: 6 }}
              textAlign="right"
              h="100%"
            >
              <HStack mb={4} spacing={3} align="center">
                <Box bg={iconBg} borderRadius="2xl" p={4}>
                  <Icon
                    verticalAlign="middle"
                    as={feature.icon as any}
                    boxSize={8}
                    color={iconColor}
                  />
                </Box>
              </HStack>

              <Heading
                as="h3"
                fontSize={{ base: "lg", md: "xl" }}
                color={textColor}
              >
                {feature.title}
              </Heading>

              <Text
                mt={3}
                fontSize={{ base: "sm", md: "md" }}
                color={subtitleColor}
                lineHeight="tall"
              >
                {feature.description}
              </Text>
            </Box>
          </MotionBox>
        ))}
      </SimpleGrid>
    </VStack>
  );
};
